/**
 * @description pc,sp リンク出し分け
 */

import { isSumaho } from '../common/isSumaho';

export const switchLink = () => {
  const target = $('.js-switchlink');
  if (!target.length) return;

  target.each((i, e) => {
    const splink = $(e).data('splink');
    if (isSumaho()) $(e).attr('href', `${splink}`);
  });
};
